<template>
  <div
    :class="{
      'section': hasNoModifier,
      'section--no-bottom-padding': noBottomPadding,
      'section--no-top-padding': noTopPadding,
      'section--no-padding': noPadding,
      'section--hero': isHero,
      'section--padding-l-extra': paddingLExtra
    }">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Section",
  props: {
    noBottomPadding: { type: Boolean, default: false },
    noTopPadding: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
    isHero: { type: Boolean, default: false },
    paddingLExtra: { type: Boolean, default: false }
  },
  computed: {
    hasNoModifier() {
      return !this.paddingLExtra && !this.noBottomPadding && !this.noTopPadding && !this.noPadding && !this.isHero;
    }
  }
};
</script>
